import React from "react";
import { Box, Button, FormHelperText } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

export default function AddEditUserDialog(props) {
    // Department membership is CMMS administration (Cmms_Manager on the endpoints), so the
    // section is absent — not disabled — for anyone who could not save it anyway.
    const showDepartments = props.canManageDepartments === true;

    // null means the existing membership has not arrived yet. Rendering an enabled, empty
    // select there would read as "belongs to nothing", and a selection made in that window
    // would be overwritten the moment the fetch lands.
    const departmentsPending = props.user.departments == null;

    return (
        <Box 
            sx={{
                p:1,
                m:1
            }}>
                <Box sx={{width: 400}}>
                    { props.user.id === null ? (
                        <AxionControls.AxionTextBox 
                            name="username"
                            label={<FormattedMessage {...messages.usernameColumnLabel} />}
                            value={props.user.username}
                            onChange={props.onChange}
                        />
                    ) : (
                        <AxionControls.AxionTextBoxReadOnly 
                            name="username"
                            label={<FormattedMessage {...messages.usernameColumnLabel} />}
                            value={props.user.username}
                            onChange={props.onChange}
                        />
                    )}
                </Box>
                <Box sx={{width: 400}}>
                    <AxionControls.AxionTextBox 
                        name="name"
                        label={<FormattedMessage {...messages.nameColumnLabel} />}
                        value={props.user.name}
                        onChange={props.onChange}
                    />
                </Box>
                <Box sx={{width: 400, mt:2}}>
                    <AxionControls.AxionSelect
                        name="roles"
                        label={<FormattedMessage {...messages.rolesColumnLabel} />}
                        value={props.user.roles}
                        onChange={props.onRolesChange}
                        options={props.roles.map(role => ({ id: role.id, title: role.roleName })) || []}
                        multiple={true}
                        showNoneOption={false}
                    />
                </Box>
                {showDepartments && (
                    <Box sx={{width: 400, mt:2}}>
                        <AxionControls.AxionSelect
                            name="departments"
                            label={<FormattedMessage {...messages.departmentsLabel} />}
                            value={props.user.departments ?? []}
                            onChange={props.onDepartmentsChange}
                            options={(props.departments ?? []).map(d => ({ id: d.id, title: d.name }))}
                            multiple={true}
                            showNoneOption={false}
                            disabled={departmentsPending}
                        />
                        <FormHelperText>
                            <FormattedMessage
                                {...(departmentsPending ? messages.departmentsLoading : messages.departmentsHelp)} />
                        </FormHelperText>
                    </Box>
                )}
               <Box>
                    <Button
                        variant="contained"
                        sx={{
                            marginTop: 2,
                            }}
                        onClick={props.handleSave}>
                        <FormattedMessage {...messages.save} />
                    </Button>
                </Box>
        </Box>
    );
}